import { render } from "./ReceivableMoney.vue?vue&type=template&id=1be61dd8"
import script from "./ReceivableMoney.vue?vue&type=script&lang=js"
export * from "./ReceivableMoney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__